import { UserRole } from '@enmon/commons/lib/enmon';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { APP_DICTIONARY } from '../root';

export const USER_ROLES_TRANSLATED = defineMessages<UserRole>({
  [UserRole.Admin]: { id: 'app.common.userRoles.admin' },
  [UserRole.Magic]: { id: 'app.common.userRoles.magic' },
  [UserRole.User]: { id: 'app.common.userRoles.user' },
  [UserRole.Tenant]: { id: 'app.common.userRoles.tenant' },
  [UserRole.Demo]: { id: 'app.common.userRoles.demo' },

  // NOTE: Unused in UI
  [UserRole.Tools]: { id: 'app.common.userRoles.tools' },
  [UserRole.Meters]: APP_DICTIONARY.meters,
});
